// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"60a1e29d","505":"f37aaa32"}[chunkId] + ".chunk.js";
};